<template>
  <div class="enable-cam">
    <Icon name="grCameraPlus" width="36" class="mb-3"/>
    <div class="mb-4">
      <h1 class="title mb-2">{{ $t('pages.checkins.camera_error_title') }}</h1>
      <h4 class="subtitle">
        {{ $t('pages.checkins.camera_error_subtitle') }}
      </h4>
    </div>
    <div v-if="instructions">
      <div class="instructions">
        <div v-for="instruction in instructions" :key="instruction.key">
          <div class="d-flex instruction">
            <div><span class="num">{{ instruction.key }}</span></div>
            <div v-html="instruction.text"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!instructions">
      <p>Enable camera of your browser</p>
    </div>
  </div>
</template>
<script>
import {BrowserDetector} from "@/utils/browserDetector";
import {browserInstructions} from "@/domain/checkin/browserInstructions";
import {mapGetters} from "vuex";

export default {
  name: "EnableCam",
  computed: {
    ...mapGetters(["isPicaThirdLevelDomain", 'thirdLevelDomain']),
    instructions() {
      const currentBrowserPlatform = BrowserDetector.get()
      console.log('currentBrowserPlatform', currentBrowserPlatform)
      const instructions = browserInstructions[BrowserDetector.get()]
      if (!instructions) return null

      return instructions.map((instruction) => {
        return {
          key: instruction.key,
          text: this.$t(`enable_cam.${currentBrowserPlatform}.${instruction.key}`, {
            icon: instruction.icon ? "<img class='mx-1' src=" + require('@/assets/instructions/' + instruction.icon) + " />" : "",
            domain: this.isPicaThirdLevelDomain ? 'getpica.com' : this.thirdLevelDomain + '.getpica.com',
          }),
        }
      })
    }
  },
}
</script>
<style scoped>

</style>